import { contactData } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
          {contactData.title}
        </h2>
        <p className="mt-3 text-sm text-foreground-500 leading-relaxed max-w-xl mx-auto">
          {contactData.description}
        </p>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-5">
          <div className="p-6 bg-background-100 rounded-lg">
            <span className="w-12 h-12 flex items-center justify-center mx-auto text-primary-500">
              <i className="ri-mail-line text-2xl"></i>
            </span>
            <h3 className="mt-3 font-heading text-base font-semibold text-foreground-900">
              电子邮箱
            </h3>
            <p className="mt-1 text-sm text-foreground-500 break-all">
              {contactData.email}
            </p>
          </div>

          <div className="p-6 bg-background-100 rounded-lg">
            <span className="w-12 h-12 flex items-center justify-center mx-auto text-accent-500">
              <i className="ri-wechat-line text-2xl"></i>
            </span>
            <h3 className="mt-3 font-heading text-base font-semibold text-foreground-900">
              微信公众号
            </h3>
            <p className="mt-1 text-sm text-foreground-500">
              {contactData.wechat}
            </p>
          </div>

          <div className="p-6 bg-background-100 rounded-lg">
            <span className="w-12 h-12 flex items-center justify-center mx-auto text-secondary-500">
              <i className="ri-qq-line text-2xl"></i>
            </span>
            <h3 className="mt-3 font-heading text-base font-semibold text-foreground-900">
              QQ群
            </h3>
            <p className="mt-1 text-sm text-foreground-500">
              {contactData.qq}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}